<template>
  <div class="home">
    <div>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>

</style>
